import React, { useEffect, useCallback,  Suspense, lazy } from "react";
import Load from "../common/Loader/Load";
import { useSection } from "../context/SectionContext";
import { ListServices } from "../assets/list-services";

const Welcome = lazy(() => import("../components/scroll/Welcome"));
const Nights = lazy(() => import("./Nights"));
const PlaceOrder = lazy(() => import("./PlaceOrder"));
const BenefitsCards = lazy(() => import("../components/ui/cards/BenefitsCards"));

export const Home = () => {
  const { setActiveSection } = useSection();

  const handleScroll = useCallback(() => {
    const sections = ["welcome", "nights", "placeOrder"];
    let currentSection = "";

    sections.forEach((section) => {
      const element = document.getElementById(section);
      if (
        element &&
        element.getBoundingClientRect().top <= window.innerHeight / 2
      ) {
        currentSection = section;
      }
    });

    if (currentSection !== "") {
      setActiveSection(currentSection);
    }
  }, [setActiveSection]);

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    handleScroll();
    return () => window.removeEventListener("scroll", handleScroll);
  }, [handleScroll]);

  return (
    <Suspense fallback={<Load />}>
      <div id="welcome">
        <Welcome />
      </div>
      <div id="services">
        <BenefitsCards data={ListServices}/>
      </div>
      <div id="nights">
        <Nights />
      </div>
      <div id="placeOrder">
        <PlaceOrder />
      </div>
    </Suspense>
  );
};
